import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { addressDescriptionItem, contactDescriptionItems } from '@app/icare/components/entity/EntityDescriptionItems'
import { MedicalTechnologyEditDrawer } from '@app/icare/routes/_app/medizintechnik/-components/MedicalTechnologyEditDrawer'
import { t } from '@lingui/core/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'

export const Route = createFileRoute('/_app/medizintechnik/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  const medicalTechnology = data

  return (
    <Flex vertical gap="small">
      <ProCard
        headerBordered
        title={t`Allgemein`}
        extra={
          <EditSectionButton onClick={() => void MedicalTechnologyEditDrawer.show({ id: data.id, section: 'basic' })} />
        }
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Name`}>{medicalTechnology.name}</TypedDescriptionsItem>
          {addressDescriptionItem(medicalTechnology.address)}
          {contactDescriptionItems(medicalTechnology.contact)}
        </ProDescriptions>
      </ProCard>
      <ProCard
        headerBordered
        title={t`Sonstiges`}
        extra={
          <EditSectionButton onClick={() => void MedicalTechnologyEditDrawer.show({ id: data.id, section: 'misc' })} />
        }
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Bemerkungen`}>{medicalTechnology.comment}</TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
